// @generated by protoc-gen-es v1.10.0 with parameter "target=ts,import_extension=.ts"
// @generated from file qliq_protobuf/api_error_code.proto (package qliq_protobuf, syntax proto3)
/* eslint-disable */
// @ts-nocheck

import { proto3 } from "@bufbuild/protobuf";

/**
 * @generated from enum qliq_protobuf.ApiErrorCode
 */
export enum ApiErrorCode {
  /**
   * @generated from enum value: API_ERROR_UNKNOWN = 0;
   */
  API_ERROR_UNKNOWN = 0,

  /**
   * AUTH errors 1..49
   *
   * @generated from enum value: AUTH_INVALID_ACCESS_REFRESH_TOKENS_PAIR = 1;
   */
  AUTH_INVALID_ACCESS_REFRESH_TOKENS_PAIR = 1,

  /**
   * BD (BotDesigner) errors 50..100
   *
   * @generated from enum value: BD_DESIGN_IS_IN_USE = 50;
   */
  BD_DESIGN_IS_IN_USE = 50,

  /**
   * CC (CareCampaigns) errors 101..199
   *
   * @generated from enum value: CC_NOT_ALLOWED_WITHOUT_SUBSCRIPTION = 101;
   */
  CC_NOT_ALLOWED_WITHOUT_SUBSCRIPTION = 101,

  /**
   * @generated from enum value: CC_CANNOT_REMOVE_WHEN_SET_TO_CAMPAIGN = 102;
   */
  CC_CANNOT_REMOVE_WHEN_SET_TO_CAMPAIGN = 102,

  /**
   * @generated from enum value: CC_MESSAGE_SEQUENCE_INCOMPLETE = 103;
   */
  CC_MESSAGE_SEQUENCE_INCOMPLETE = 103,

  /**
   * @generated from enum value: CC_CHANGE_WILL_CAUSE_DUPLICATES = 104;
   */
  CC_CHANGE_WILL_CAUSE_DUPLICATES = 104,

  /**
   * @generated from enum value: CC_SFTP_CONFIG_IS_NOT_ACTIVE = 105;
   */
  CC_SFTP_CONFIG_IS_NOT_ACTIVE = 105,

  /**
   * @generated from enum value: CC_NO_SFTP_SOURCE_IS_CONFIGURED = 106;
   */
  CC_NO_SFTP_SOURCE_IS_CONFIGURED = 106,

  /**
   * @generated from enum value: CC_NO_SFTP_RECIPIENT_SOURCE_IS_CONFIGURED = 107;
   */
  CC_NO_SFTP_RECIPIENT_SOURCE_IS_CONFIGURED = 107,

  /**
   * @generated from enum value: CC_AUTO_CAMPAIGN_IS_EXPIRED = 108;
   */
  CC_AUTO_CAMPAIGN_IS_EXPIRED = 108,

  /**
   * @generated from enum value: CC_AUTO_CAMPAIGN_MESSAGE_SEQUENCE_IS_INCOMPLETE = 109;
   */
  CC_AUTO_CAMPAIGN_MESSAGE_SEQUENCE_IS_INCOMPLETE = 109,

  /**
   * CW (ChatWidget) errors 200..299
   *
   * @generated from enum value: CW_CANNOT_REMOVE_AGENT_SET_TO_CONV_RULES = 200;
   */
  CW_CANNOT_REMOVE_AGENT_SET_TO_CONV_RULES = 200,

  /**
   * @generated from enum value: CW_CANNOT_REMOVE_LAST_AGENT = 201;
   */
  CW_CANNOT_REMOVE_LAST_AGENT = 201,

  /**
   * @generated from enum value: CW_CANNOT_UNSET_AUTOASSIGNMENT_AGENT = 202;
   */
  CW_CANNOT_UNSET_AUTOASSIGNMENT_AGENT = 202,

  /**
   * @generated from enum value: CW_PHONE_NUMBER_IS_INVALID = 203;
   */
  CW_PHONE_NUMBER_IS_INVALID = 203,

  /**
   * @generated from enum value: CW_OAUTH_IS_NOT_CONFIGURED = 204;
   */
  CW_OAUTH_IS_NOT_CONFIGURED = 204,

  /**
   * FQ (FAQ) errors 300..399
   * GS (GroupSettings) errors 400..499
   *
   * @generated from enum value: GS_MIRTH_AUTH_ERROR = 400;
   */
  GS_MIRTH_AUTH_ERROR = 400,

  /**
   * @generated from enum value: GS_API_KEY_NOT_FOUND = 401;
   */
  GS_API_KEY_NOT_FOUND = 401,

  /**
   * @generated from enum value: GS_CANNOT_SELF_REMOVE_LAST_GROUP = 402;
   */
  GS_CANNOT_SELF_REMOVE_LAST_GROUP = 402,

  /**
   * @generated from enum value: GS_EMR_NOT_ENABLED = 403;
   */
  GS_EMR_NOT_ENABLED = 403,

  /**
   * @generated from enum value: GS_CALLERID_ALREADY_VERIFIED = 404;
   */
  GS_CALLERID_ALREADY_VERIFIED = 404,

  /**
   * @generated from enum value: GS_USER_NAME_ALREADY_TAKEN = 405;
   */
  GS_USER_NAME_ALREADY_TAKEN = 405,

  /**
   * @generated from enum value: GS_NOT_ALLOWED = 406;
   */
  GS_NOT_ALLOWED = 406,

  /**
   * @generated from enum value: GS_INVALID_GENERATED_PASSWORD = 407;
   */
  GS_INVALID_GENERATED_PASSWORD = 407,

  /**
   * @generated from enum value: GS_SSO_IDP_URL_UNREACHABLE = 408;
   */
  GS_SSO_IDP_URL_UNREACHABLE = 408,

  /**
   * @generated from enum value: GS_CANNOT_REMOVE_LAST_OWNER = 409;
   */
  GS_CANNOT_REMOVE_LAST_OWNER = 409,

  /**
   * HD (Header) errors 500..599
   * OS (OncallSchedules) errors 600.699
   * PC (PatientChat) errors 700..799
   *
   * @generated from enum value: PC_CHAT_WIDGET_UNAVAILABLE = 700;
   */
  PC_CHAT_WIDGET_UNAVAILABLE = 700,

  /**
   * @generated from enum value: PC_CHAT_WIDGET_NOT_LOADED = 701;
   */
  PC_CHAT_WIDGET_NOT_LOADED = 701,

  /**
   * @generated from enum value: PC_VISITANT_IS_NOT_LOADED = 702;
   */
  PC_VISITANT_IS_NOT_LOADED = 702,

  /**
   * @generated from enum value: PC_AUTH_IS_REQUESTED_BUT_IMPOSSIBLE = 703;
   */
  PC_AUTH_IS_REQUESTED_BUT_IMPOSSIBLE = 703,

  /**
   * @generated from enum value: PC_AUTH_WRONG_SECRET = 704;
   */
  PC_AUTH_WRONG_SECRET = 704,

  /**
   * @generated from enum value: PC_AUTH_OUT_OF_ATTEMPTS = 705;
   */
  PC_AUTH_OUT_OF_ATTEMPTS = 705,

  /**
   * @generated from enum value: PC_AUTH_STRATEGY_IS_NOT_AVAILABLE = 706;
   */
  PC_AUTH_STRATEGY_IS_NOT_AVAILABLE = 706,

  /**
   * @generated from enum value: PC_AUTH_ROUTE_IS_NOT_AVAILABLE = 707;
   */
  PC_AUTH_ROUTE_IS_NOT_AVAILABLE = 707,

  /**
   * @generated from enum value: PC_AUTH_VISITOR_CANT_ACCESS_CHAT = 708;
   */
  PC_AUTH_VISITOR_CANT_ACCESS_CHAT = 708,

  /**
   * @generated from enum value: PC_CONVERSATION_CANT_ACCEPT_NEW_MESSAGES = 709;
   */
  PC_CONVERSATION_CANT_ACCEPT_NEW_MESSAGES = 709,

  /**
   * @generated from enum value: PC_SHORT_URL_EXPIRED = 710;
   */
  PC_SHORT_URL_EXPIRED = 710,

  /**
   * @generated from enum value: PC_CONVERSATION_IS_CLOSED = 711;
   */
  PC_CONVERSATION_IS_CLOSED = 711,

  /**
   * @generated from enum value: PC_PARTICIPATION_NOT_FOUND = 712;
   */
  PC_PARTICIPATION_NOT_FOUND = 712,

  /**
   * @generated from enum value: PC_RTC_SESSION_TERMINATED = 713;
   */
  PC_RTC_SESSION_TERMINATED = 713,

  /**
   * @generated from enum value: PC_TAC_SHOULD_BE_ACCEPTED = 714;
   */
  PC_TAC_SHOULD_BE_ACCEPTED = 714,

  /**
   * @generated from enum value: PC_USER_IS_NOT_ALLOWED = 715;
   */
  PC_USER_IS_NOT_ALLOWED = 715,

  /**
   * @generated from enum value: PC_NEW_CONVERSATION_CREATING_DISALLOWED_BY_TIME_LAPSE = 716;
   */
  PC_NEW_CONVERSATION_CREATING_DISALLOWED_BY_TIME_LAPSE = 716,

  /**
   * @generated from enum value: PC_UNKNOWN_PATIENT = 717;
   */
  PC_UNKNOWN_PATIENT = 717,

  /**
   * @generated from enum value: PC_CANNOT_FIND_ASSIGNEE = 718;
   */
  PC_CANNOT_FIND_ASSIGNEE = 718,

  /**
   * @generated from enum value: PC_TAC_ALREADY_ACCEPTED = 719;
   */
  PC_TAC_ALREADY_ACCEPTED = 719,

  /**
   * @generated from enum value: PC_CANNOT_CONTINUE_AUTO_CAMPAIGN_CONVERSATION = 720;
   */
  PC_CANNOT_CONTINUE_AUTO_CAMPAIGN_CONVERSATION = 720,

  /**
   * QF (QuickForm) errors 800..899
   *
   * @generated from enum value: QF_NOT_ALLOWED = 800;
   */
  QF_NOT_ALLOWED = 800,

  /**
   * RP (Reports) errors 900..999
   * SS (SelfSchedules) errors 1000..1099
   *
   * @generated from enum value: SS_RESOURSE_NAME_ALREADY_TAKEN = 1000;
   */
  SS_RESOURSE_NAME_ALREADY_TAKEN = 1000,

  /**
   * US (UserSettings) errors 1100..1199
   *
   * @generated from enum value: US_INVALID_CURRENT_PASSWORD = 1100;
   */
  US_INVALID_CURRENT_PASSWORD = 1100,

  /**
   * @generated from enum value: US_INVALID_NEW_PASSWORD = 1101;
   */
  US_INVALID_NEW_PASSWORD = 1101,

  /**
   * @generated from enum value: US_NOT_ALLOWED = 1102;
   */
  US_NOT_ALLOWED = 1102,

  /**
   * VC (VirtualConversation) errors 1200..1299
   *
   * @generated from enum value: VC_INVALID_ASSIGNEE = 1200;
   */
  VC_INVALID_ASSIGNEE = 1200,

  /**
   * @generated from enum value: VC_RTC_SESSION_NOT_SPECIFIED = 1201;
   */
  VC_RTC_SESSION_NOT_SPECIFIED = 1201,

  /**
   * @generated from enum value: VC_RTC_SESSION_NOT_FOUND = 1202;
   */
  VC_RTC_SESSION_NOT_FOUND = 1202,

  /**
   * @generated from enum value: VC_MISSING_REQUIRED_EMR_FIELDS = 1203;
   */
  VC_MISSING_REQUIRED_EMR_FIELDS = 1203,

  /**
   * @generated from enum value: VC_OPERATION_PROHIBITED = 1204;
   */
  VC_OPERATION_PROHIBITED = 1204,

  /**
   * GP (GptStore) errors 1300..1399
   *
   * @generated from enum value: GP_CANNOT_DEPLOY_WORKPLACE = 1300;
   */
  GP_CANNOT_DEPLOY_WORKPLACE = 1300,

  /**
   * SA (SuperAdmin) errors 1400..1499
   *
   * @generated from enum value: SA_CANNOT_REMOVE_LAST_SUPEROWNER = 1400;
   */
  SA_CANNOT_REMOVE_LAST_SUPEROWNER = 1400,

  /**
   * @generated from enum value: SA_CANNOT_REMOVE_SELF = 1401;
   */
  SA_CANNOT_REMOVE_SELF = 1401,

  /**
   * @generated from enum value: SA_GROUP_ACTION_NOT_ALLOWED = 1402;
   */
  SA_GROUP_ACTION_NOT_ALLOWED = 1402,

  /**
   * EP (Entity Preview) errors 1500..1599
   *
   * @generated from enum value: EP_GROUP_INACCESSIBLE = 1500;
   */
  EP_GROUP_INACCESSIBLE = 1500,

  /**
   * MC (Miscellaneous) errors 1600..1699
   *
   * @generated from enum value: MC_INVALID_GENERATED_PASSWORD = 1600;
   */
  MC_INVALID_GENERATED_PASSWORD = 1600,

  /**
   * QW(QliqChat Web) errors 1700..1799
   *
   * @generated from enum value: QW_KEY_NOT_FOUND = 1700;
   */
  QW_KEY_NOT_FOUND = 1700,
}
// Retrieve enum metadata with: proto3.getEnumType(ApiErrorCode)
proto3.util.setEnumType(ApiErrorCode, "qliq_protobuf.ApiErrorCode", [
  { no: 0, name: "API_ERROR_UNKNOWN" },
  { no: 1, name: "AUTH_INVALID_ACCESS_REFRESH_TOKENS_PAIR" },
  { no: 50, name: "BD_DESIGN_IS_IN_USE" },
  { no: 101, name: "CC_NOT_ALLOWED_WITHOUT_SUBSCRIPTION" },
  { no: 102, name: "CC_CANNOT_REMOVE_WHEN_SET_TO_CAMPAIGN" },
  { no: 103, name: "CC_MESSAGE_SEQUENCE_INCOMPLETE" },
  { no: 104, name: "CC_CHANGE_WILL_CAUSE_DUPLICATES" },
  { no: 105, name: "CC_SFTP_CONFIG_IS_NOT_ACTIVE" },
  { no: 106, name: "CC_NO_SFTP_SOURCE_IS_CONFIGURED" },
  { no: 107, name: "CC_NO_SFTP_RECIPIENT_SOURCE_IS_CONFIGURED" },
  { no: 108, name: "CC_AUTO_CAMPAIGN_IS_EXPIRED" },
  { no: 109, name: "CC_AUTO_CAMPAIGN_MESSAGE_SEQUENCE_IS_INCOMPLETE" },
  { no: 200, name: "CW_CANNOT_REMOVE_AGENT_SET_TO_CONV_RULES" },
  { no: 201, name: "CW_CANNOT_REMOVE_LAST_AGENT" },
  { no: 202, name: "CW_CANNOT_UNSET_AUTOASSIGNMENT_AGENT" },
  { no: 203, name: "CW_PHONE_NUMBER_IS_INVALID" },
  { no: 204, name: "CW_OAUTH_IS_NOT_CONFIGURED" },
  { no: 400, name: "GS_MIRTH_AUTH_ERROR" },
  { no: 401, name: "GS_API_KEY_NOT_FOUND" },
  { no: 402, name: "GS_CANNOT_SELF_REMOVE_LAST_GROUP" },
  { no: 403, name: "GS_EMR_NOT_ENABLED" },
  { no: 404, name: "GS_CALLERID_ALREADY_VERIFIED" },
  { no: 405, name: "GS_USER_NAME_ALREADY_TAKEN" },
  { no: 406, name: "GS_NOT_ALLOWED" },
  { no: 407, name: "GS_INVALID_GENERATED_PASSWORD" },
  { no: 408, name: "GS_SSO_IDP_URL_UNREACHABLE" },
  { no: 409, name: "GS_CANNOT_REMOVE_LAST_OWNER" },
  { no: 700, name: "PC_CHAT_WIDGET_UNAVAILABLE" },
  { no: 701, name: "PC_CHAT_WIDGET_NOT_LOADED" },
  { no: 702, name: "PC_VISITANT_IS_NOT_LOADED" },
  { no: 703, name: "PC_AUTH_IS_REQUESTED_BUT_IMPOSSIBLE" },
  { no: 704, name: "PC_AUTH_WRONG_SECRET" },
  { no: 705, name: "PC_AUTH_OUT_OF_ATTEMPTS" },
  { no: 706, name: "PC_AUTH_STRATEGY_IS_NOT_AVAILABLE" },
  { no: 707, name: "PC_AUTH_ROUTE_IS_NOT_AVAILABLE" },
  { no: 708, name: "PC_AUTH_VISITOR_CANT_ACCESS_CHAT" },
  { no: 709, name: "PC_CONVERSATION_CANT_ACCEPT_NEW_MESSAGES" },
  { no: 710, name: "PC_SHORT_URL_EXPIRED" },
  { no: 711, name: "PC_CONVERSATION_IS_CLOSED" },
  { no: 712, name: "PC_PARTICIPATION_NOT_FOUND" },
  { no: 713, name: "PC_RTC_SESSION_TERMINATED" },
  { no: 714, name: "PC_TAC_SHOULD_BE_ACCEPTED" },
  { no: 715, name: "PC_USER_IS_NOT_ALLOWED" },
  { no: 716, name: "PC_NEW_CONVERSATION_CREATING_DISALLOWED_BY_TIME_LAPSE" },
  { no: 717, name: "PC_UNKNOWN_PATIENT" },
  { no: 718, name: "PC_CANNOT_FIND_ASSIGNEE" },
  { no: 719, name: "PC_TAC_ALREADY_ACCEPTED" },
  { no: 720, name: "PC_CANNOT_CONTINUE_AUTO_CAMPAIGN_CONVERSATION" },
  { no: 800, name: "QF_NOT_ALLOWED" },
  { no: 1000, name: "SS_RESOURSE_NAME_ALREADY_TAKEN" },
  { no: 1100, name: "US_INVALID_CURRENT_PASSWORD" },
  { no: 1101, name: "US_INVALID_NEW_PASSWORD" },
  { no: 1102, name: "US_NOT_ALLOWED" },
  { no: 1200, name: "VC_INVALID_ASSIGNEE" },
  { no: 1201, name: "VC_RTC_SESSION_NOT_SPECIFIED" },
  { no: 1202, name: "VC_RTC_SESSION_NOT_FOUND" },
  { no: 1203, name: "VC_MISSING_REQUIRED_EMR_FIELDS" },
  { no: 1204, name: "VC_OPERATION_PROHIBITED" },
  { no: 1300, name: "GP_CANNOT_DEPLOY_WORKPLACE" },
  { no: 1400, name: "SA_CANNOT_REMOVE_LAST_SUPEROWNER" },
  { no: 1401, name: "SA_CANNOT_REMOVE_SELF" },
  { no: 1402, name: "SA_GROUP_ACTION_NOT_ALLOWED" },
  { no: 1500, name: "EP_GROUP_INACCESSIBLE" },
  { no: 1600, name: "MC_INVALID_GENERATED_PASSWORD" },
  { no: 1700, name: "QW_KEY_NOT_FOUND" },
]);

